/**
 * MasterAdmin utility functions
 * MasterAdmins are ROBOTOP employees with full platform access
 */

// MasterAdmin user IDs (should match server-side)
const MASTER_ADMIN_IDS = [
  'e9e4356c-a072-436b-a612-e30bd07fc03a', // teb2@byom.de (dev)
  'c9fdebf1-2829-4d19-8cfd-4f5d6586f5c6', // tony.phan@robotop.de (prod)
  'b105abf4-ac5a-48d7-8f0d-48b84a1a9147', // baris.erdoenmez@robotop.de (prod)
  '8bba5719-b8dc-430f-b2ec-ba16fbaf5a4f', // eike.schaeffer@robotop.de (prod)
  '43124f5c-b06b-49dd-8410-f03a37a16c71', // nicolas.falbesaner@robotop.de (prod)
];

/**
 * Check if current user is a MasterAdmin
 * @param userProfile The user profile object
 * @returns boolean indicating if current user is a MasterAdmin
 */
export const isCurrentUserMasterAdmin = (userProfile: { _id: string }): boolean => {
  return MASTER_ADMIN_IDS.includes(userProfile._id);
};
